import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

import './styles/main.scss';

import Header from './components/header';
import Analytics from "./utils/analytics";
import CookieConsentModal from "./utils/cookieConsentModal";

import Intro from './pages/intro';
import About from './pages/about';
import Skill from './pages/skill';
import Certificates from './pages/certificates';
import Contact from './pages/contact';
import Legal from './pages/legal';

const Portfolio = React.lazy(() => import('./pages/portfolio'));

const COOKIE_NAME = "eduardoCookieConsent";

function hasUserConsented() {
    const consent = localStorage.getItem(COOKIE_NAME);
    return consent === "accepted" || consent === "declined";
}

function App() {
    const { i18n } = useTranslation(); 
    const [showLegal, setShowLegal] = useState(false);
    const [showCookieConsent, setShowCookieConsent] = useState(() => !hasUserConsented());

    useEffect(() => {
        if (!hasUserConsented()) {
            setShowCookieConsent(true);
        }
    }, []);

    const openLegalModal = useCallback(() => {
        setShowCookieConsent(false); 
        setShowLegal(true);
    }, []);

    const closeLegalModal = useCallback(() => {
        setShowLegal(false);
    }, []);

    const openCookieConsentFromLegal = useCallback(() => {
        setShowLegal(false);
        setShowCookieConsent(true);
    }, []);


    return (<>
        <Helmet>
            <html lang={i18n.language} />
        </Helmet>
        <div className="App" >
            {!showLegal && (
                <CookieConsentModal
                    visible={showCookieConsent}
                    onOpenLegal={openLegalModal} 
                    onClose={() => setShowCookieConsent(false)}
                />
            )}
            <Analytics />

            <Header openLegalModal={openLegalModal} />
            <Intro />
            <About />
            <Skill />
            <Portfolio />
            <Certificates />
            <Contact openLegalModal={openLegalModal} /> 
            
            {showLegal && (
                <Legal
                    onClose={closeLegalModal}
                    onOpenCookieConsent={openCookieConsentFromLegal}
                />
            )}
        </div>
    </>
    );
}

export default App;